import { render } from "./RecordChecks.vue?vue&type=template&id=096dae29&scoped=true"
import script from "./RecordChecks.vue?vue&type=script&lang=js"
export * from "./RecordChecks.vue?vue&type=script&lang=js"

import "./RecordChecks.vue?vue&type=style&index=0&id=096dae29&scoped=true&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096dae29"]])

export default __exports__